import React, { Component } from 'react';
import { View, Image } from '@zhike/ti-ui';
import { formatDuration } from 'utils';
import Header from 'components/header';
import styles from './styles';

// 阅读指令
export default class Resting extends Component {
  // 构造函数
  constructor(props) {
    super(props);
    this.state = {
      time: 10 * 60 * 1000,
      percent: 0,
    };
    this.timeInterval = null;
  }

  // 模块加载
  componentDidMount() {
    Header.config({
      showButtons: ['testStop', 'testNext'],
      isShowTime: false,
    });
    this.timeInterval = setInterval(() => {
      if (Header.getTime() === 0) {
        clearInterval(this.timeInterval);
        Header.next();
        return;
      }

      this.setState({
        time: Header.getTime(),
        percent: (this.state.time - 10) / (10 * 60 * 1000),
      });
    }, 10);
  }

  // 模块卸载
  componentWillUnmount() {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
      this.timeInterval = null;
    }
  }

  // 渲染
  render() {
    const { time, percent } = this.state;
    return (
      <View className={styles.container}>
        {/* eslint-disable */}
        <Image
          className={styles.image}
          src={require('components/assets/default.png')}
        />
        <View className={styles.p}>休息一下吧</View>
        <View className={styles.p}>10分钟倒计时结束后，自动进入下一个测试部分 </View>
        <View className={styles.p}>你也可以点击右上角Continue直接跳过</View>
        <View className={styles.time}>
          <View className={styles.timeText}>
            BREAK TIME
          </View>
          <View className={styles.progress}>
            <View className={styles.progressText}>
              {formatDuration(time, true)}
            </View>
            <View
              className={styles.progressBar}
              style={{ width: percent * 400 }}
            />
          </View>
        </View>
        {/* eslint-enable */}
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/testPages/resting/index.js